
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppSelect, AppCard, AppButton } from '@/components';
import { useGameVariantTranslate } from '@/modules/game/variant/model/translate';
import { ROUTE_NAME_GAME } from '@/modules/game/router';

export default defineComponent({
    name: ROUTE_NAME_GAME.VARIANT.TRANSLATE,
    components: { AppFormRow, AppInput, AppSelect, AppCard, AppButton },
    setup() {
        const { model, localeSupportedOptions, beforeFetch, fetch, actions } = useGameVariantTranslate();

        onMounted(async () => {
            await beforeFetch();
            await fetch();
        });

        return { model, localeSupportedOptions, fetch, actions };
    }
});
